import type { TrackerChatMessage } from '@/components/Messenger/types/chatMessageTypes';
import {
  formatToolResult,
  type ToolPart,
} from '@/components/Messenger/agent/agentMessageRender/toolFormatting';

/** Текст для пересылки / черновика DM без разметки. */
export function plainTextFromAssistantMessageParts(
  parts: TrackerChatMessage['parts'] | undefined
): string {
  if (!parts?.length) return '';
  const lines: string[] = [];
  for (const part of parts) {
    if (part.type === 'text' && 'text' in part) {
      const t = typeof part.text === 'string' ? part.text.trim() : '';
      if (t) lines.push(t);
      continue;
    }
    if (part.type === 'reasoning') continue;
    if (part.type.startsWith('tool-') || part.type === 'dynamic-tool') {
      const toolPart = part as ToolPart;
      const state = toolPart.state;
      const isResult = state === 'output-available' || state === 'output-error';
      if (!isResult) continue;
      const toolName = toolPart.toolName ?? part.type.replace(/^tool-/, '');
      const output = toolPart.output;
      const errorText = toolPart.errorText;
      const hasErrorInOutput = typeof output === 'object' && output !== null && 'error' in output;
      const rawError =
        errorText ?? (hasErrorInOutput ? String((output as { error: string }).error) : null);
      const summary = rawError
        ? rawError.startsWith('Ошибка')
          ? rawError
          : `Ошибка: ${rawError}`
        : formatToolResult(output, toolName, toolPart.input);
      if (summary) lines.push(summary);
    }
  }
  return lines.join('\n\n').trim();
}
